exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button {\r\n    height: 60px;\r\n    width: 160px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-left: 3px solid white;\r\n    cursor: pointer;\r\n}\r\n\r\n    .button:hover {\r\n        background: rgba(0,0,0, 0.10);\r\n    }\r\n\r\n.title {\r\n    width: 160px;\r\n    height: 60px;\r\n    font-size: 20px;\r\n    color: #fff;\r\n    text-align: center;\r\n\r\n    margin: 0;\r\n    padding: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.small {\r\n    width: 80px;\r\n    height: 60px;\r\n    font-size: 10px;\r\n}\r\n\r\n.logoBtn {\r\n    width: 100%;\r\n    height: 100%;\r\n    font-size: 12px;\r\n    border-left: 0;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/buttons/bar-button.component.css
// module id = 2289
// module chunks = 1